import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import T from 'prop-types'
import {
  fetchMyLogTable,
  removeLogRow,
  clearMyLogTable,
  reloadMyLogTable,
} from 'reducers/digitalLogbook/reducer'
import withPromise from 'helpers/withPromise'
import { getTime } from 'helpers/timeFrames'
import ListFromTable from '../common/ListFromTable'
import ColumnCollection from '../../types/table/ColumnCollection'
import Column from '../../types/table/Column'
import ActionCollection from '../../types/table/ActionCollection'
import Action from '../../types/table/Action'
import messages from './translate'

class MyLogTable extends ListFromTable {
  static contextTypes = {
    router: T.shape({
      history: T.object.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.deleteEntity = this.props.removeLogRow
    this.clearReducerState = this.props.clearMyLogTable
    this.asyncData = true
    this.loadingData = true
  }

  componentDidMount() {
    const { activeSite, activeCage, activeDate } = this.props
    this.psfs.addSort('containerName')
    this.getTableData(activeSite, activeCage, activeDate)
  }

  shouldComponentUpdate(nextProps) {
    const { activeSite, activeCage, activeDate, tableData } = this.props
    const changeProps =
      activeSite !== nextProps.activeSite ||
      activeCage !== nextProps.activeCage ||
      activeDate !== nextProps.activeDate

    if (
      changeProps ||
      nextProps.location.pathname !== this.props.location.pathname ||
      nextProps.isReloadMyLogTable
    ) {
      if (changeProps) {
        this.psfs.paginationObj.setPage(1)
        this.context.router.history.replace(this.psfs.path)
      }

      this.getTableData(
        nextProps.activeSite,
        nextProps.activeCage,
        nextProps.activeDate,
      )

      return false
    }

    if (tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return true
  }

  getTableData = (activeSite, activeCage, activeDate) => {
    if (activeSite) {
      this.props.fetchMyLogTable({
        siteId: activeSite,
        cageId: +activeCage,
        date: activeDate.format('YYYY-MM-DD'),
        psfs: this.psfs,
      })
    }
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.logbook_history),
      showFilterBar: false,
      sorting: true,
      paging: true,
      searching: false,
      creating: false,
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.delete_log),
      message: formatMessage(messages.delete_log_message),
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()
    columns.add(
      new Column('containerName', formatMessage(messages.cage), {
        sorting: true,
        render: rowData => rowData.cagename,
      }),
    )
    columns.add(
      new Column('type', formatMessage(messages.type), {
        sorting: true,
        render: () => 'SLA',
      }),
    )
    columns.add(
      new Column('status', formatMessage(messages.status), {
        sorting: true,
        render: () => 'Completed',
      }),
    )
    columns.add(
      new Column('username', formatMessage(messages.logged), { sorting: true }),
    )
    columns.add(new Column('comment', formatMessage(messages.comment)))
    columns.add(
      new Column('time', formatMessage(messages.time), {
        sorting: true,
        render: rowData => getTime(rowData.hour, rowData.minute),
      }),
    )
    columns.add(
      new Column('rate', formatMessage(messages.value), {
        sorting: true,
        render: rowData => (rowData.rate === 5 ? 'X' : rowData.rate),
      }),
    )

    return columns
  }

  onConfirmActionConfirmDialog = () => {
    const { confirmParams } = this.state

    if (confirmParams) {
      withPromise(this.deleteEntity, confirmParams).then(errors => {
        if (errors) return Promise.resolve(errors)

        this.props.reloadMyLogTable(true)
      })
    }

    this.onCloseConfirmDialog()
  }

  getActions() {
    const { activeSite, activeCage, activeDate } = this.props
    const actions = new ActionCollection()
    actions.add(
      new Action('delete', 'Remove entry', row => {
        this.onOpenConfirmDialog({
          logId: row.id,
          siteId: activeSite,
          cageId: +activeCage,
          date: +activeDate.format('YYYYMMDD'),
          psfs: this.psfs,
        })
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    isReloadMyLogTable: state.getIn(['digitalLogbook', 'isReloadMyLogTable']),
    tableData: state.getIn(['digitalLogbook', 'myLogTable']),
    activeSite: state.getIn(['profile', 'siteId']),
    activeCage: state.getIn(['digitalLogbook', 'activeCage']),
    activeDate: state.getIn(['digitalLogbook', 'activeDate']),
  }),
  {
    fetchMyLogTable,
    removeLogRow,
    clearMyLogTable,
    reloadMyLogTable,
  },
)(injectIntl(MyLogTable))
